import { FC } from "react";

export type ParallaxGlassesPropsType = {
  progress: number;
};

const ParallaxGlasses: FC<ParallaxGlassesPropsType> = ({ progress }) => {
  return (
    <div className="decorative-glasses hidden lg:block fixed w-full h-screen overflow-hidden z-0">
      <div
        className="glass-2 absolute -right-16 top-28 w-28 h-28"
        style={{ transform: `translateY(${-5 * progress}%)` }}
      ></div>
      <div
        className="glass-2 absolute -right-6 top-40 w-96 h-96"
        style={{ transform: `translateY(${+0.5 * progress}%)` }}
      ></div>
      <div
        className="glass-2 absolute -left-10 top-96 w-52 h-52"
        style={{ transform: `translateY(${-2 * progress}%)` }}
      ></div>
      <div
        className="glass-2 absolute -left-16 top-80 w-28 h-28"
        style={{ transform: `translateY(${-3 * progress}%)` }}
      ></div>
      <div
        className="glass-2 absolute -right-16 top-[30rem] w-52 h-52"
        style={{ transform: `translateY(${-progress}%)` }}
      ></div>
      <div
        className="glass-2 absolute -right-24 top-[70rem] w-28 h-28"
        style={{ transform: `translateY(${-progress}%)` }}
      ></div>
    </div>
  );
};

export default ParallaxGlasses;
